import { useEffect, useState } from 'react';
import { getCurrentWeather, getForecast } from '../services/weatherService';

const REFRESH_MS = 10 * 60 * 1000;

export default function useLocalForecast({ lat, lon }) {
  const [result, setResult] = useState(null);
  const [revision, setRevision] = useState(0);
  const key = `${lat},${lon}`;

  useEffect(() => {
    let active = true;
    let pending = false;
    let lastAttempt = 0;
    async function refresh() {
      if (pending) return;
      pending = true;
      lastAttempt = Date.now();
      setResult((previous) => ({
        ...(previous?.key === key ? previous : {}),
        key,
        loading: true,
      }));
      const [current, forecast] = await Promise.allSettled([
        getCurrentWeather(lat, lon, { includeUvi: false }),
        getForecast(lat, lon),
      ]);
      if (active) {
        setResult({
          key,
          loading: false,
          current: current.status === 'fulfilled' ? current.value : null,
          data: forecast.status === 'fulfilled' ? forecast.value : null,
          fetchedAt: new Date(),
        });
      }
      pending = false;
    }
    const onVisible = () => {
      if (!document.hidden && Date.now() - lastAttempt >= REFRESH_MS) refresh();
    };
    refresh();
    const timer = setInterval(onVisible, REFRESH_MS);
    document.addEventListener('visibilitychange', onVisible);
    return () => {
      active = false;
      clearInterval(timer);
      document.removeEventListener('visibilitychange', onVisible);
    };
  }, [key, lat, lon, revision]);

  return {
    ...(result?.key === key ? result : { loading: true }),
    refresh: () => setRevision((value) => value + 1),
  };
}
